module.exports = __webpack_public_path__ + "img/4step-01-03-1_ergebnis.92cc163c.png";